import React from 'react';
export function GuaranteeSection() {
  return <section className="py-8 bg-brand-light border-t border-gray-200" data-id="element-95">
      <div className="container mx-auto px-6 max-w-3xl text-center" data-id="element-96">
        <p className="text-sm text-gray-500 leading-relaxed" data-id="element-97">
          <strong className="font-semibold text-gray-700" data-id="element-98">Aviso Legal:</strong>{' '}
          Este es un producto educativo diseñado para ayudarte a tomar mejores
          decisiones financieras. Los resultados dependerán de tu situación
          personal, historial previo y aplicación consistente del contenido. No
          garantizamos un aumento específico en tu puntaje de crédito.
        </p>
      </div>
    </section>;
}